module.exports = __webpack_public_path__ + "static/media/download-black.d6ec512f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/download-black.svg
// module id = 59
// module chunks = 0